import { render, staticRenderFns } from "./profiles-section.vue?vue&type=template&id=272439b2&scoped=true&"
import script from "./profiles-section.vue?vue&type=script&lang=js&"
export * from "./profiles-section.vue?vue&type=script&lang=js&"
import style0 from "./profiles-section.vue?vue&type=style&index=0&id=272439b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272439b2",
  null
  
)

export default component.exports